import { useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import { useNavigate } from "react-router-dom";
import "./PlantationTwoFAQ.scss";
import { useCollection } from "../../../../firebase-files/hooks/useCollection";

const PlantationTwoFAQ = () => {
  const [expandedCategory, setExpandedCategory] = useState(null);
  const [showAll, setShowAll] = useState({});
  const navigate = useNavigate();

  const { documents: categories } = useCollection("m_categories", [
    "source",
    "==",
    "faq",
  ]);

  const { documents: faqs } = useCollection("faqs");

  const toggleCategory = (categoryId) => {
    setExpandedCategory(expandedCategory === categoryId ? null : categoryId);
  };

  const toggleShowAll = (categoryId) => {
    setShowAll((prev) => ({
      ...prev,
      [categoryId]: !prev[categoryId],
    }));
  };

  return (
    <section className="eco_faq_section">
      <div className="container">
        <div className="row align-items-center">
          {/* FAQ Content Section */}
          <div className="col-lg-6 col-md-12">
            <div className="faq_content">
              <h2 className="faq_title">Frequently Asked Questions</h2>
              <p className="faq_desc">
                Our objective is to provide the freshest and most beautiful
                flowers for every occasion, ensuring timely delivery, elegant
                presentation, and memorable experiences for our customers.
              </p>

              <div className="faq-categories">
                {categories &&
                  categories.map((category) => {
                    const categoryFaqs = faqs
                      ? faqs.filter(
                          (f) =>
                            f.category?.toLowerCase() ===
                            category.category?.toLowerCase()
                        )
                      : [];

                    return (
                      <div key={category.id} className="faq-category">
                        <button
                          className="category-header"
                          onClick={() => toggleCategory(category.id)}
                          aria-expanded={expandedCategory === category.id}
                          aria-controls={`category-${category.id}-content`}
                        >
                          {category.icon && (
                            <span className="category-icon" aria-hidden="true">
                              {category.icon}
                            </span>
                          )}
                          <h3 className="category-title">
                            {category.category}
                          </h3>
                          <span className="toggle-icon">
                            {expandedCategory === category.id ? "−" : "+"}
                          </span>
                        </button>

                        {expandedCategory === category.id &&
                          categoryFaqs.length > 0 && (
                            <div
                              id={`category-${category.id}-content`}
                              className="category-content"
                            >
                              <Accordion
                                defaultActiveKey="0"
                                className="faq_accordion"
                              >
                                {(showAll[category.id]
                                  ? categoryFaqs
                                  : categoryFaqs.slice(0, 3)
                                ).map((faq, index) => (
                                  <Accordion.Item
                                    key={index}
                                    eventKey={index.toString()}
                                    className="accordion-item"
                                  >
                                    <Accordion.Header className="accordion-header">
                                      {faq.question}
                                    </Accordion.Header>
                                    <Accordion.Body className="accordion-body">
                                      {faq.answer}
                                    </Accordion.Body>
                                  </Accordion.Item>
                                ))}
                              </Accordion>

                              {categoryFaqs.length > 3 && (
                                <button
                                  className="see-more-btn"
                                  onClick={() => toggleShowAll(category.id)}
                                >
                                  {showAll[category.id]
                                    ? "Show Less"
                                    : `See More ${category.category} FAQs`}
                                </button>
                              )}
                            </div>
                          )}
                      </div>
                    );
                  })}

                <button
                  className="see-all-faqs-btn"
                  onClick={() => navigate("/faq")}
                >
                  See More
                </button>
              </div>
            </div>
          </div>

          {/* Right-side Image */}
          <div className="col-lg-6 col-md-12">
            <div className="faq-image-container">
              <img
                src="/assets/img/faq image.webp"
                alt="FAQ Illustration"
                className="faq-direct-image"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PlantationTwoFAQ;
